import React from 'react';
import Tile from '../tile/tile';

const FilterResult = ({ hit, sendEvent }) => {
  const onClick = () => {
    sendEvent('click', hit, 'Article Clicked');
  };

  return (
    <div>
      <Tile
        onClick={() => onClick()}
        isSearchTile={true}
        id={hit.id}
        flagAsOldContent={hit.flagAsOldContent}
        tileType="standard"
        contentType={hit.pageType}
        url={hit.url}
        title={hit.listingTitle}
        description={hit.listingDescription}
        imageUrl={hit.images ? hit.images : hit.file && hit.file.url}
        images={hit.images}
        imageAlt={hit.title}
        resourceContentType={hit.resourceContentType?.map(r => r.title)}
        tags={hit.topics}
        tagLimit={3}
      />
    </div>
  );
};

export default FilterResult;
